// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3604 ? "DynamicSearch" : chunkId) + "." + {"3604":"2f0cf10906f7415c","5374":"d128a471237d863b"}[chunkId] + ".js";
};